import i18next, { type TFunction } from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import { CONTACT_DETAILS } from '@/config/contactDetails'
import { defaultLanguage, resolveLanguage, supportedLanguages } from '@/config/locales'
// import { isDev } from '@/utils/env';

const i18nReady: Promise<TFunction> = i18next
  .use(initReactI18next)
  .use(Backend)
  .init({
    // debug: isDev,
    lng: resolveLanguage(localStorage.getItem('tmc_language')),
    fallbackLng: defaultLanguage,
    supportedLngs: supportedLanguages,
    // beide talen vooraf laden: taalwissel is dan instant, zonder Suspense-remount (scrollsprong)
    preload: supportedLanguages,
    load: 'languageOnly',
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: {
      defaultVariables: {
        contactEmail: CONTACT_DETAILS.emailAddress,
        contactPhone: CONTACT_DETAILS.phoneNumber,
      },
    },
    ns: [
      'common',
      'auth',
      'navigation',
      'dashboard',
      'appointment',
      'invoices',
      'questions',
      'onboarding',
      'documents',
      'settings',
      'feedback',
      'install',
      'videoCall',
      'diary',
      'tmc',
      'zorgpad',
      'medication'
    ] as const,
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  })

export default i18nReady
